'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function GYFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("mask", { id: "mantine-cz6wx4i46", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-cz6wx4i46)" }, /* @__PURE__ */ React.createElement("path", { fill: "#5eaa22", d: "M0 0h32v24H0z" }), /* @__PURE__ */ React.createElement("g", { strokeWidth: "2" }, /* @__PURE__ */ React.createElement("path", { fill: "#feca00", stroke: "#f7fcff", d: "M1 1.413L30.995 12 1 22.587z" }), /* @__PURE__ */ React.createElement("path", { fill: "#e11c1b", stroke: "#272727", d: "M-1 .045L14.371 12-1 23.955z" }))))
  );
}

export { GYFlag };
//# sourceMappingURL=GY.mjs.map
